// extracted by mini-css-extract-plugin
module.exports = {"card":"Success_card__2ZsvI"};